import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home-container">
      <div className="hero">
        <h1>Let's Get Started</h1>
        <p>Manage Patient Alcohol Consumption</p>
        <Link to="/assessment-history" className="cta-button">
          Get started
        </Link>
      </div>
    </div>
  );
}

export default Home;
